<template>
	<div class="wrapper">
		<AppHeader />
		<AppAside />
		<AppContentWrapper />
	</div>
</template>
<script>
	import AppHeader from './components/header.vue';
	import AppAside from './components/aside.vue';
	import AppContentWrapper from './components/content.wrapper.vue';

	export default {
		name: 'CntApp',
		components: { AppHeader, AppAside, AppContentWrapper },
	};
</script>
<style>
	.h1,
	h1 {
		color: #434c48 !important;
	}
	.skin-green .wrapper,
	.skin-green .main-sidebar,
	.skin-green .left-side {
		background-color: #fc561c !important;
	}
	.skin-green .sidebar-menu > li > a {
		height: 44px !important;
	}
	.sidebar-menu:hover {
		overflow: hidden !important;
	}

	.skin-green .main-header .navbar {
		background-color: #01416f !important;
	}
	.skin-green .main-header .navbar .sidebar-toggle:hover {
		background-color: #d04312 !important;
	}
	.skin-green .sidebar a {
		color: #fff !important;
	}
	.skin-green .sidebar-menu .treeview-menu > li > a {
		color: #d6e6df !important;
	}
	.skin-green .sidebar-menu > li:hover > a,
	.skin-green .sidebar-menu > li.active > a,
	.skin-green .sidebar-menu > li.menu-open > a {
		color: #fff !important;
		background: #d04312 !important;
	}
	.skin-green .sidebar-menu > li.active > a {
		border-left-color: #fff !important;
	}
	.skin-green .sidebar-menu > li > .treeview-menu {
		margin: 0 1px !important;
		background: #f76f40 !important;
	}
	.main-sidebar::-webkit-scrollbar-track {
		background-color: #fc561c !important;
	}
	.main-sidebar::-webkit-scrollbar-thumb {
		background: #d04312 !important;
	}
	.main-sidebar::-webkit-scrollbar {
		width: 3px !important;
		background: #fc561c !important;
	}
	.sidebar-menu > li > a > .fa,
	.sidebar-menu > li > a > .glyphicon,
	.sidebar-menu > li > a > .ion {
		font-size: 22px !important;
		float: left !important;
		margin: -2px 10px -17px -4px !important;
	}
	.skin-green .sidebar-menu .treeview-menu > li.active > a {
		color: #fff !important;
		text-decoration: underline !important;
	}

	.skin-green .main-header .logo {
		background-color: #d04312 !important;
	}
	.skin-green .main-header .logo:hover {
		background-color: #d04312 !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/cnt-app/index.vue